import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react'
import { Combobox } from 'medere-ui-framework'
import { Dropdown } from 'primereact/dropdown'
import { getRequestingDoctors } from '../../Agenda/services/AgendaService'
import { PatientSearchResult } from '../../Agenda/types/agenda.types'
import PatientSelector, { PatientSelectorValue } from '../../Agenda/components/PatientSelector'
import { getStudyTypes } from '../../../services/StudiesInformController'

export interface ManualStudyInformValue {
  patient: PatientSearchResult | null
  requestingDoctor: { id: number; name: string } | null
  studyTypeId: string | null
  studyTypeLabel: string | null
}

export const emptyManualStudyInformValue: ManualStudyInformValue = {
  patient: null,
  requestingDoctor: null,
  studyTypeId: null,
  studyTypeLabel: null,
}

interface ManualStudyInformFieldsProps {
  value: ManualStudyInformValue
  onChange: Dispatch<SetStateAction<ManualStudyInformValue>>
  disabled?: boolean
}

export function ManualStudyInformFields({ value, onChange, disabled = false }: Readonly<ManualStudyInformFieldsProps>) {
  const [studyTypeOptions, setStudyTypeOptions] = useState<Array<{ label: string; value: string }>>([])

  useEffect(() => {
    getStudyTypes().then(setStudyTypeOptions).catch(() => setStudyTypeOptions([]))
  }, [])

  // Mismo selector de paciente que la Agenda; el informe solo admite pacientes registrados
  const handlePatientChange = useCallback((selection: PatientSelectorValue) => {
    const patient = selection.mode === 'identify' ? selection.data?.patient ?? null : null
    onChange((prev) => ({ ...prev, patient }))
  }, [onChange])

  return (
    <>
      <div className='study-inform-card mb-3'>
        <div className='study-inform-card-header'>
          <span className='studies-inform-section-title'>Paciente</span>
        </div>
        <div className='studies-inform-crud-field'>
          <PatientSelector
            visible={true}
            showContactFields={false}
            allowCreate
            showModeTabs={false}
            onChange={handlePatientChange}
          />
        </div>
      </div>

      <div className='study-inform-card mb-3'>
        <div className='study-inform-card-header'>
          <span className='studies-inform-section-title'>Datos del estudio</span>
        </div>
        <div className='studies-inform-crud-field mb-3'>
          <label className='studies-inform-crud-field-label'>Tipo de estudio</label>
          <Dropdown
            options={studyTypeOptions}
            optionLabel='label'
            optionValue='value'
            value={value.studyTypeId}
            onChange={(e) => {
              const studyTypeId = (e.value ?? null) as string | null
              const studyTypeLabel = studyTypeOptions.find((o) => o.value === studyTypeId)?.label ?? null
              onChange((prev) => ({ ...prev, studyTypeId, studyTypeLabel }))
            }}
            placeholder='Seleccionar tipo de estudio'
            className='w-full'
            disabled={disabled}
          />
        </div>
        <div className='studies-inform-crud-field'>
          <label className='studies-inform-crud-field-label'>Médico solicitante</label>
          <Combobox
            className='studies-inform-crud-combobox'
            getItems={getRequestingDoctors}
            optionLabel='name'
            placeholder='Seleccionar médico solicitante'
            setValue={(doctor: { id: number; name: string } | null) => onChange((prev) => ({ ...prev, requestingDoctor: doctor ?? null }))}
            value={value.requestingDoctor}
            disable={disabled}
          />
        </div>
      </div>
    </>
  )
}
